
import {
  Component,
  Vue
} from 'vue-property-decorator'
import {
  AuthModule
} from '@/store/modules/AuthModule'
// import OfficeJob from './components/Jobs/OfficeJobs.vue'
  @Component({
    name: 'Job'
  })
export default class Job extends Vue {
  get table () {
    if (AuthModule.permissions.includes('op@office')) {
      return () => import('./components/Table/Office.vue')
    }

    if (AuthModule.permissions.includes('op@barge')) {
      return () => import('./components/Table/Barge.vue')
    }

    if (AuthModule.permissions.includes('op@slpa')) {
      return () => import('./components/Table/SLPA.vue')
      // return () => import('./components/Table/SLPA.vue')
    }
  }
}

